export const contentPathsSegments = {
    content: 'content',
    dataProtection: 'datenschutzerklaerung'
};

export const contentPaths = {
    dataProtection: '/' + contentPathsSegments.content + '/' + contentPathsSegments.dataProtection
};
